// Initialisation de l'objet queryParams pour stocker les paramètres de requête
Shopify.queryParams = {};

/*********************************************************************************************
* Refresh the collection page with the provided filters.
	*
	* @param {string} url_filters - The URL parameters for the filters.
*/
function refreshCollectionPageWithFilters(url_filters) {
    let currentUrl = '//' + location.host + location.pathname;
    let newPageString = httpGet(`${currentUrl}?${url_filters}&section_id=${returnShopifySectionIdShort()}`);

    // Créer un nouvel élément DIV pour insérer le HTML récupéré
    let newPageEl = document.createElement('DIV');
    newPageEl.innerHTML = newPageString;

    // Mise à jour des articles de la collection avec les nouveaux filtres
    var newSection = newPageEl.querySelector('.mm-grid-card-collection');
    document.querySelector('.mm-grid-card-collection').innerHTML = newSection.innerHTML;

	// Refresh mm-filter-types
	var newFilter = newPageEl.querySelector('.mm-filter-types');
    document.querySelector('.mm-filter-types').innerHTML = newFilter.innerHTML;


    // Mise à jour des filtres actifs
    // var activeFilters = newPageEl.querySelectorAll('.active-filters');
    // activeFilters.forEach(function (activeFilter) {
    //     var newActiveFilters = document.querySelectorAll('.active-filters');
    //     newActiveFilters.forEach(function (newActiveFilter) {
    //         newActiveFilter.innerHTML = activeFilter.innerHTML;
    //     });
    // });

    // Mise à jour des autres éléments avec la classe 'mm-reload'
    var reloadElems = newPageEl.querySelectorAll('.mm-reload');
    reloadElems.forEach(function (reloadElem, index) {
        var newElems = document.querySelectorAll('.mm-reload');
        newElems[index].innerHTML = reloadElem.innerHTML;
    });

    // Mise à jour de l'URL dans l'historique sans recharger la page
    window.history.replaceState(null, document.title, currentUrl + '?' + url_filters);
    document.querySelector('.mm-grid-card-collection').classList.remove('mm-loading');

    // Vérifie les changements dans les filtres après le rafraîchissement
    checkForChanges();
}

/*********************************************************************************************
* Return the Shopify section ID of the collection grid.
	*
	* @returns {string} - The section ID of the grid.
*/
function returnShopifySectionId() {
    const gridElem = document.querySelector('.mm-grid-collection');
    const gridSection = gridElem.closest('.shopify-section');
    return gridSection.id;
}

	/*********************************************************************************************
	* Splide Tabs
		*
	*/
	document.addEventListener('DOMContentLoaded', function() {
			const splideElem = document.querySelector('.mm-filter-group-types');
		  
			const splideInstance = new Splide(splideElem, {
			  type: 'slide',            // Mode slide (défilement horizontal)
			  arrows: false,            // Pas de flèches
			  pagination: false,        // Pas de pagination
			  drag: 'free',             // Glissement libre
			  autoWidth: true,  
			});
		  
			splideInstance.mount();
		  });

	// Fonction pour gérer le comportement sticky Nav
		document.addEventListener("DOMContentLoaded", function() {
		const mmGridSecondContainerFilter = document.querySelector('.mm-grid-second-container-filter');
		let initialTopPosition = mmGridSecondContainerFilter.offsetTop - 75;

		function handleScroll() {
			if (window.scrollY >= initialTopPosition) {
				mmGridSecondContainerFilter.classList.add('sticky');
			} else {
				mmGridSecondContainerFilter.classList.remove('sticky');
			}
		}

		window.addEventListener('scroll', handleScroll);
	});


/*********************************************************************************************
* Return the Shopify section ID without the 'shopify-section-' prefix.
	*
	* @returns {string} - The shortened section ID.
*/
function returnShopifySectionIdShort() {
    return returnShopifySectionId().replace('shopify-section-', '');
}

/*********************************************************************************************
* Perform a synchronous GET request.
	*
	* @param {string} theUrl - The URL to request.
	* @returns {string} - The response text from the request.
*/
function httpGet(theUrl) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open('GET', theUrl, false);  // Synchronous request
    xmlHttp.send(null);
    return xmlHttp.responseText;
}

/*********************************************************************************************
* Check for changes in the filter inputs and submit the form if changes are detected.
	*
*/
function checkForChanges() {
    var form = document.getElementById('collectionFacetsForm');
    var inputs = form.querySelectorAll('input');
	
	// inputs.forEach(function (input) {
	// 	if (input !== inputCheck) {
	// 	  input.checked = false;
	// 	}
	//   });

	

    // Ajouter un listener sur chaque input pour détecter les changements
     inputs.forEach(function (input) {
        input.addEventListener('change', function () {
			inputs.forEach(function (filter) {
				if (input !== filter) {
					filter.checked = false; // Désélectionne
				}
			})
			fakeSubmitForm();
		});
    });
}


/*********************************************************************************************
* Update the sort_by query parameter and reload the page with the new sorting applied.
	*
	* @param {HTMLSelectElement} select - The select element for sorting.
*/
function mmSortByChanged(select) {
    const hiddenSelect = document.getElementById('mmSortByHiddenElem');
    hiddenSelect.value = select.value;
    fakeSubmitForm();
}

/*********************************************************************************************
* Adds a listener on the change of select for sorting
	*
*/
document.addEventListener('DOMContentLoaded', function () {
    const sortByElem = document.querySelector('.sort_by');
    if (sortByElem) {
        sortByElem.addEventListener('change', function (e) {
            var value = e.target.value;
            Shopify.queryParams.sort_by = value;
            location.search = new URLSearchParams(Shopify.queryParams).toString();
        });
    }
});

/*********************************************************************************************
* Serialize the form data and refresh the collection page with the filters.
	*
*/
function fakeSubmitForm() {
    let form = document.getElementById("collectionFacetsForm");
    let url_filters = new URLSearchParams(new FormData(form)).toString();
    document.querySelector('.mm-grid-card-collection').classList.add('mm-loading');

	console.log('url filter', url_filters)

    // Rafraîchir la collection avec les filtres
    setTimeout(() => {
        refreshCollectionPageWithFilters(url_filters);
    }, "0");
}

window.addEventListener('DOMContentLoaded', (event) => {
    checkForChanges();
	// mmFiltersAccordeons();
});
